export const MANAGE_STOCKTABLEDATA = "MANAGE_STOCKTABLEDATA"
export const ISSUE_STOCKTABLEDATA = "ISSUE_STOCKTABLEDATA"
export const BUS_STATION = "BUS_STATION"
export const COUNTER_LIST = "COUNTER_LIST"
export const SKIP_STOCKTABLEDATA = "SKIP_STOCKTABLEDATA"
export const TRASFER_STOCKTABLEDATA = "TRASFER_STOCKTABLEDATA"


